import { Typography } from "@mui/material";
import { formatDistanceToNow, parseISO } from "date-fns";
import { PipelinePickup } from "../types";

type Props = {
  pendingVendor: NonNullable<PipelinePickup["pendingVendor"]>;
};

export function PendingConfirmationCardContent({ pendingVendor }: Props) {
  const sentAgo = formatDistanceToNow(parseISO(pendingVendor.sentAt), { addSuffix: false });

  return (
    <Typography variant="body2" mt={1.5} sx={{ fontSize: 13, lineHeight: 1.4 }}>
      <Typography component="span" variant="body2" fontWeight={600} color="text.primary" sx={{ fontSize: 13 }}>
        {pendingVendor.vendorName}
      </Typography>
      <Typography component="span" color="text.secondary" sx={{ fontSize: 13 }}>
        {" — sent "}
        {sentAgo} ago
      </Typography>
    </Typography>
  );
}
